import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { UserTrackingService } from 'src/app/user-tracking/services/user-tracking.service';
import { HeatmapService } from './user-tracking/services/heatmap.service';
import { HeatmapComponent } from './user-tracking/heatmap/heatmap.component';
import { UserPreferencesService } from './services/user-preferences.service';
import { WebSocketService } from './services/websocket.service';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HeatmapComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    private authService: MsalService,
    private router: Router,
    private userTrackingService: UserTrackingService,
    public heatmapService: HeatmapService,
    private userPreferencesService: UserPreferencesService,
    private webSocketService: WebSocketService,
  ) {}

  ngOnInit(): void {
    if (!sessionStorage.getItem("session_id")) {
      sessionStorage.setItem("session_id", uuid());
    }

    // User tracking: navigation events and screen clicks.
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.userTrackingService.logRoute(event.urlAfterRedirects);
      }
    })
    
    this.authService.handleRedirectObservable().subscribe({
      next: (result) => {
        // Check if we got a response from the redirect
        if (result && result.account) {
          this.authService.instance.setActiveAccount(result.account);
        } else {
          // If there are no accounts, attempt to log in
          const accounts = this.authService.instance.getAllAccounts();
          if (accounts.length > 0) {
            this.authService.instance.setActiveAccount(accounts[0]);
          }
        }

        // A signed-out first load emits here too (no redirect result, no account).
        // MsalGuard is about to start the login redirect, so stay off the API: a
        // request now goes through AuthInterceptor, which starts a second
        // loginRedirect. MSAL rejects it with interaction_in_progress and clears the
        // first redirect's state, so the response is dropped on return and sign-in loops.
        if (!this.authService.instance.getActiveAccount()) {
          return;
        }

        this.userTrackingService.updateUserInfo();

        // Load persisted preferences from the backend so that cross-device
        // changes made on another browser/machine are reflected immediately.
        this.userPreferencesService.loadFromBackend().subscribe();

        // Open the reusable WebSocket connection for real-time server push.
        this.webSocketService.connect();
      }
    });
  }
  
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    this.userTrackingService.logClick(event)
  }
}
